// elevation.js — batch ground-elevation lookups via Open-Meteo (no API key).
//
// Google Maps' JS ElevationService needs the "Elevation API" enabled *and*
// allowed on REACT_APP_GOOGLE_MAPS_KEY; when it isn't, every call fails with
// REQUEST_DENIED (which is what this project's key returns). Open-Meteo's
// elevation endpoint is keyless, CORS-enabled, and accepts up to 100
// coordinates per request, so it works straight from the browser with no Google
// Cloud configuration. Elevation is sourced from the Copernicus GLO-90 DEM —
// ample resolution for a project's site context.
//
// fetchElevations([{ id, lat, lng }]) → Promise<Map<id, metres>>.

const ENDPOINT = 'https://api.open-meteo.com/v1/elevation';
const BATCH = 100;

export async function fetchElevations(points) {
  const valid = (points || []).filter(p => Number.isFinite(p.lat) && Number.isFinite(p.lng));
  const out = new Map();
  if (!valid.length) return out;

  for (let i = 0; i < valid.length; i += BATCH) {
    const batch = valid.slice(i, i + BATCH);
    const lat = batch.map(p => p.lat).join(',');
    const lng = batch.map(p => p.lng).join(',');
    // eslint-disable-next-line no-await-in-loop
    const res = await fetch(`${ENDPOINT}?latitude=${lat}&longitude=${lng}`);
    if (!res.ok) throw new Error(`Elevation lookup failed (HTTP ${res.status}).`);
    // eslint-disable-next-line no-await-in-loop
    const data = await res.json();
    const elev = data && data.elevation;
    if (!Array.isArray(elev)) throw new Error('Elevation service returned no data.');
    elev.forEach((m, idx) => {
      const p = batch[idx];
      if (p && Number.isFinite(m)) out.set(p.id, m);
    });
  }
  return out;
}
